import HttpService from "./htttp.service";
import Swal from "sweetalert2";
import { requestUpgrade } from "context/upgrade";

let interceptorId = null;

export const setupAxiosInterceptors = (onUnauthenticated) => {
  // Chamada a cada mudança do AuthContext: troca o interceptor anterior em vez de empilhar.
  // O header Authorization já é posto pelo próprio HttpService (construtor); registrar outro
  // interceptor de request aqui acumulava um por chamada e todos rodavam em cada requisição.
  if (interceptorId !== null) {
    HttpService.ejectResponseInterceptor(interceptorId);
  }

  const onResponseSuccess = (response) => response;

  const onResponseFail = (error) => {
    const status = error.status || error.response?.status;

    if (status === 401) {
      const currentPath = window.location.pathname;
      
      // Lista de rotas públicas onde o erro 401 deve ser ignorado pelo interceptor
      const publicRoutes = [
        "/auth/login",
        "/auth/register", 
        "/auth/forgot-password",
        "/auth/reset-password"
      ];
      const isPublicRoute = publicRoutes.some(route => currentPath.includes(route));

      if (!isPublicRoute) {
        onUnauthenticated();
      }
    } else if (status === 403) {
      const data = error.response?.data || {};
      const message = data.message || "";

      // Não empilhar alertas (ex.: várias chamadas premium falhando juntas)
      if (Swal.isVisible()) return Promise.reject(error);

      switch (data.code) {
        case "premium_required":
          requestUpgrade();
          break;
        case "lead_locked":
          Swal.fire({
            icon: "info",
            title: "Pedido bloqueado",
            text: "Libere o contato deste pedido antes de continuar.",
          });
          break;
        case "admin_required":
          Swal.fire({ icon: "error", title: "Acesso negado", text: "Você não tem permissão para acessar este recurso." });
          break;
        default: {
          // Legado (check.subscription antes do freemium): sem "code", decide pelo texto
          const lower = message.toLowerCase();
          const isExpired =
            lower.includes("assinatura expirada") ||
            lower.includes("subscription expired") ||
            lower.includes("assinatura inativa") ||
            data.status === "inactive";

          if (isExpired && window.location.pathname !== "/billing") {
            Swal.fire({
              icon: "error",
              title: "Assinatura Expirada",
              text: "Sua assinatura expirou. Regularize para continuar usando este recurso.",
              showCancelButton: true,
              confirmButtonText: "Ver meu plano",
              cancelButtonText: "Fechar",
            }).then((result) => {
              if (result.isConfirmed) window.location.href = "/billing";
            });
          } else {
            Swal.fire({ icon: "warning", title: "Atenção", text: message || "Ação não permitida." });
          }
        }
      }
    }

    return Promise.reject(error);
  };
  interceptorId = HttpService.addResponseInterceptor(onResponseSuccess, onResponseFail);
};
